import { createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '@shared/api/client';

export const fetchDisabledFeatures = createAsyncThunk(
  'disabledfeatures/fetchDisabledfeatures',
  async (_, { rejectWithValue }) => {
    try {
      const response = await client.get(`/system/disabledfeatures`);

      if (response.ok) {
        return { ok: true, data: response.data };
      }

      return rejectWithValue({
        error: response.data?.message || 'Failed to load disabled features',
        status: response.status,
      });
    } catch (error) {
      return rejectWithValue({
        error: typeof error === 'string' ? error : 'Network error',
        status: null,
      });
    }
  },
);